import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionModule, KngButtonModule, KngCardListModule, KngDialogTooltipModule, KngFilterPanelModule, KngLoaderModule, KngTableLoaderModule, ModalModule } from 'kinetic-angular';
import { AnalyticsModule } from '../../services/analytics/analytics.module';
import { CustomerSupportComponent } from './customer-support.component';
import { CustomerSupportService } from './customer-support.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [CustomerSupportComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		KngLoaderModule,
		KngButtonModule, 
		AccordionModule, 
		AnalyticsModule,
		KngFilterPanelModule,
		KngDialogTooltipModule, 
		KngCardListModule,
		KngTableLoaderModule, 
		ModalModule
	],
	exports: [CustomerSupportComponent],
	providers: [CustomerSupportService]
})
export class CustomerSupportModule { }
